export type menuItem = {
  id: number;
  url: string;
  title: string;
  redirectTo: string;
  img: string;
};

export const Config = {
  siteUrl: import.meta.env.VITE_SITE_URL
    ? import.meta.env.VITE_SITE_URL
    : 'https://www.yettel.rs/',
  wsUrl: import.meta.env.VITE_WS_URL
    ? import.meta.env.VITE_WS_URL
    : 'https://www.yettel.rs/webshop/',
  mojTelenorUrl: import.meta.env.VITE_MOJ_TELENOR_URL
    ? import.meta.env.VITE_MOJ_TELENOR_URL
    : 'http://ytl.rs/ya/home',
  ysdUrl: import.meta.env.VITE_YSD_URL
    ? import.meta.env.VITE_YSD_URL
    : 'https://shopping.yettel.rs/',
  yPayUrl: import.meta.env.VITE_YPAY_URL
    ? import.meta.env.VITE_YPAY_URL
    : 'https://www.yettel.rs/placanja/',
  tnAccountUrl: import.meta.env.VITE_ACCOUNT_URL
    ? import.meta.env.VITE_ACCOUNT_URL
    : 'https://www.yettel.rs/nalog/',
  tnAccountSettingUrl: import.meta.env.VITE_TN_ACCOUNT_URL
    ? import.meta.env.VITE_TN_ACCOUNT_URL
    : 'https://ytl.rs/ya/detalji-korisnika',
  tnAccountLogoutUrl: import.meta.env.VITE_TN_ACCOUNT_LOGOUT_URL
    ? import.meta.env.VITE_TN_ACCOUNT_LOGOUT_URL
    : 'https://www.yettel.rs/webshop/session-logout/',
  cartOverviewUrl: import.meta.env.VITE_CART_OVERVIEW_URL
    ? import.meta.env.VITE_CART_OVERVIEW_URL
    : 'https://www.yettel.rs/webshop/sr/sr/Privatni-korisnici/Kupovina/',
  businessPortalUrl: import.meta.env.VITE_BUSINESS_PORTAL_URL
    ? import.meta.env.VITE_BUSINESS_PORTAL_URL
    : 'https://www.yettel.rs/biznisportal/',
  hipernetUrl: import.meta.env.VITE_HIPERNET_URL
    ? import.meta.env.VITE_HIPERNET_URL
    : 'https://ytl.rs/hnapp',
  ybankUrl: import.meta.env.VITE_YBANK_URL
    ? import.meta.env.VITE_YBANK_URL
    : 'https://www.yettelbank.rs/',
  zeleneStazeUrl: import.meta.env.VITE_ZELENE_STAZE_URL
    ? import.meta.env.VITE_ZELENE_STAZE_URL
    : 'https://zelenestaze.yettel.rs/'
};

export const YETTEL_MENU_ITEMS = [
  {
    id: 1,
    title: 'Y. Webshop',
    url: Config.wsUrl,
    redirectTo: Config.wsUrl,
    img: 'shop'
  },
  {
    id: 2,
    title: 'Y. Aplikacija',
    url: Config.mojTelenorUrl,
    redirectTo: Config.mojTelenorUrl,
    img: 'portal'
  },
  {
    id: 3,
    title: 'Y. TV',
    url: Config.hipernetUrl,
    redirectTo: Config.hipernetUrl,
    img: 'hipernet'
  },
  {
    id: 4,
    title: 'Y. Banka',
    url: Config.ybankUrl,
    redirectTo: Config.ybankUrl,
    img: 'ybank'
  },
  {
    id: 5,
    title: 'Y. Shopping',
    url: Config.ysdUrl,
    redirectTo: Config.ysdUrl,
    img: 'ysd'
  },
  {
    id: 6,
    title: 'Y. Pay',
    url: Config.yPayUrl,
    redirectTo: Config.yPayUrl,
    img: 'ypay'
  },
  {
    id: 7,
    title: 'Y.Zelene staze',
    url: Config.zeleneStazeUrl,
    redirectTo: Config.zeleneStazeUrl,
    img: 'zeleneStaze'
  },
  {
    id: 8,
    title: 'Y. Nalog',
    url: Config.tnAccountUrl,
    redirectTo: Config.tnAccountUrl,
    img: 'nalog'
  }
];
